import React from 'react';
import ReactDOM from 'react-dom';

class WidgetLoadingIndicator extends React.Component {
	constructor(props) {
		super(props);

		this.ellapsed = this.props.ellapsed;

		this.state = {
			scale: !this.ellapsed ? 0.2 : 0
		};

		this.timeout = undefined;
		this.indicator;
	}

	componentDidMount() {
		if(!!this.timeout) {
			clearTimeout(this.timeout);
		}
		// setTimeout의 두번째 인자로 들어가는 milliseconds의 minimum은 10ms 임
		if(this.ellapsed === undefined) {
			this.ellapsed = 60000;
			setTimeout(() => {
				if(!!this.indicator) {
					this.setState({ scale: 0.95 });
				}
			}, 100);

		}else if(this.ellapsed <= 1000) {
			this.setState({ scale: 1 });
		}else{
			this.timeout = setTimeout( () => this.setState({ scale: 1 }), this.ellapsed*1/100 );
		}
	}

	componentWillUnmount() {
		if(!!this.timeout) {
			clearTimeout(this.timeout);
		}
	}

	render() {
		const loaderCssOption = {
			width: '100%',
			backgroundColor: '#FF692A',
			height: '1px',
			transform: `scaleX(${this.state.scale})`,
			transformOrigin: '0% 0%',
			transition: `transform ${this.ellapsed}ms ease-in-out`
		};

		var isEnded = this.props.isEnded;
		if(isEnded) {
			return (
				<div className="widget-loading" style={{backgroundColor: 'silver'}}>{this.props.children}</div>
			);
		}
		else {
			return (
				<div className="widget-loading" style={loaderCssOption} ref={ref => this.indicator = ref}></div>
			);
		}

	}
	
	shouldComponentUpdate(nextProps, nextState) {
    	// return a boolean value
    	return true;
	}

	componentWillUpdate(nextProps, nextState){
    // perform any preparations for an upcoming update
    	this.props = nextProps;
	}
};

export default WidgetLoadingIndicator;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/WidgetLoadingIndicatorComponent.jsx